/* eslint import/prefer-default-export: 0 */

import { assignedDutyStatusTypes } from 'constants/enums/employmentOptions';
import { disciplineSentenceOptions } from 'constants/enums/militaryOptions';

export const military = {
  pvq: {
    intro: {
      title: 'U.S. Military and U.S. Uniformed Service',
      body:
      'This section asks questions regarding your U.S. military or U.S. uniformed service, as applicable. The military service you listed in the employment section, if any, was based on each duty station you were assigned to in the past five years. This section requests each period of military service in which you currently serve or for which you received a DD-214, Certificate of Release or Discharge. Do not break out separate enlistment periods unless you received a DD-214. List all periods of service even if you listed them in Section 7 - Employment Activities ',
    },
    tour: {
      para: 'Take a guided tour through the section',
    },
    review: {
      para: 'View all the sections associated with military history at once',
    },
    section: {
      name: 'Military history',
    },
    subsection: {
      intro: 'Introduction',
      selective: 'Selective service record',
      history: 'U.S. military',
      disciplinary: 'Disciplinary procedures',
      foreign: 'Foreign military',
      review: 'Review',
    },
    destination: {
      intro: 'Military intro',
      selective: 'Selective service record',
      history: 'U.S. Military and U.S. Uniformed Service',
      disciplinary: 'Disciplinary procedures',
      foreign: 'Foreign military',
      review: 'Review military history',
    },
    selective: {
      heading: {
        born: 'Were you born a male after December 31, 1959?',
        registered: 'Have you registered with the Selective Service System (SSS)?',
        number: 'Provide registration number',
        message: '(The military stopped issuing Service Numbers July 1, 1969.  If you were issued a Service Number, enter it here.  If not, enter your Social Security Number)'
      },
      para: {
        or: 'or',
      },
      label: {
        idk: "I don't know",
        number: 'Note: Selective Service Number is not your Social Security Number',
        explanation: 'Provide an explanation',
      },
      aria: {
        idk: "I don't know for Have you registered with the Selective Service System (SSS)",
      },
      error: {
        birthdateBefore: { title: 'Your birthdate is prior to this date.' },
      },
      help: {
        born: {
          title: 'Why are we asking?',
          message: 'The selective service only applies to men born after this date.',
          note: '',
        },
        registered: {
          title: 'Need help with whether you have registered?',
          message:
          'The Selective Service website (see link below) provides additional resources which may assist in finding your registration number or eligibility',
          note: '',
        },
        number: {
          title: 'Need help with your registration number?',
          message:
          'If additional assistance in determining your registration number is required please refer to the Selective Service information below',
          note: '',
        },
        explanation: {
          title: 'Need help with this explanation?',
          message: "To help the investigation let us know why you haven't registered.",
          note: '',
        },
        remember: {
          title: "Can't remember your registration number?",
          message:
          'The Selective Service website, [www.sss.gov](https://www.sss.gov/) can help provide the registration number for persons who have registered.',
          note: '',
        },
      },
      comments: 'Optional Comments',
      answercomments: 'Optional Comments',
      numbercomments: 'Optional Comments',
      exemptioncomments: 'Optional Comments',
      dnkcomments: 'Optional Comments',
    },
    history: {
      heading: {
        rank: 'Rank (List the alpha-numeric identifier for highest rank achieved for this period of service such as E-1, O-3, etc.)',
        reportedwithemployment: 'Did you report this disciplinary action in section seven (7), Employment Activities?',
        served: 'Have you ever served in the U.S. military or a U.S. uniformed service?',
        served2013: 'Have you ever served in the U.S. or Foreign Military?',
        servedmerchantmarine: 'Have you ever served in the U.S. Merchant Marine?',
        service: 'Which branch of service are you or were you in?',
        status: 'What is or was your duty status?',
        officer: 'Officer or enlisted',
        number: 'Provide your service number',
        dates: 'When did you serve? (Start with your most recent period of service and work back.)',
        servicestate: 'Which state or territory do you or did you serve in the National Guard?',
        nationalguardserved: 'Provide either the state or country served',
        country: 'Country of service',
        discharged:
        'Were you discharged from this instance of U.S. military service, to include Reserves, or National Guard?',
        details: 'Discharge details',
        discharge: {
          type: 'What type of discharge or separation did you receive?',
          date: 'Provide the date of discharge listed above',
        },
      },
      label: {
        ...assignedDutyStatusTypes.asLocaleEn(),
        airforce: 'U.S. Air Force',
        airnationalguard: 'Air National Guard',
        army: 'U.S. Army',
        armynationalguard: 'Army National Guard',
        coastguard: 'U.S. Coast Guard',
        dates: {
          fromdate: 'From',
          todate: 'To',
        },
        marinecorps: 'U.S. Marine Corps',
        navy: 'U.S. Navy',
        nationalguard: 'National Guard',
        nationaloceanicatmosphericadministration: 'National Oceanic and Atmospheric Administration Commissioned Officer Corps',
        publichealthservice: 'U.S. Public Health Service Commissioned Corps',
        spaceforce: 'U.S. Space Force',
        statusotherexplanation: 'Please explain.',
        merchantmarine: 'Merchant Marine',
        officer: 'Officer',
        enlisted: 'Enlisted',
        na: 'Not applicable',
        discharge: {
          type: {
            badconduct: 'Bad Conduct Discharge',
            dishonorable: 'Dishonorable Discharge',
            dismissal: 'Dismissal',
            general: 'General Discharge Under Honorable Conditions (this is not an Honorable Discharge)',
            honorable: 'Honorable Discharge',
            otherex: 'Provide other type of discharge',
            otherthan: 'Other Than Honorable Discharge',
            othertype: 'Other Type of Separation (Entry-Level Separation, Medical Separation, Separation for Convenience of the Government)',
          },
          reason: 'Why were you discharged or separated?',
        },
        disciplinary: {
          courtmartialtype: {
            general: 'General',
            special: 'Special',
            summary: 'Summary',
          },
          explanation: 'Please explain.',
          name: {
            admonishment: 'Letter of Admonishment',
            article15: 'Article 15 (of the UCMJ)',
            courtmartial: 'Court-Martial',
            other: 'Other',
            reprimand: 'Letter of Reprimand',
          },
        },
      },
      help: {
        served: {
          title: 'Any U.S. Military branch',
          message:
          'If you have ever served in the Air Force, Air National Guard, Army, Army National Guard, Coast Guard, Marine Corps, or Navy answer "Yes".',
          note: '',
        },
        served2013: {
          title: 'Any U.S. or Foreign Military',
          message: 'If you have ever served in a U.S. or Forign Military answer "Yes".',
          note: '',
        },
        servedmerchantmarine: {
          title: 'U.S. Merchant Marine branch',
          message: 'If you have ever served in the Merchant Marine answer "Yes".',
          note: '',
        },
        service: {
          title: 'Need help with the branch of service?',
          message: 'Please provide the branch of service you belonged to during this period',
          note: '',
        },
        status: {
          title: 'Need help with your status?',
          message: 'Provide your current status with this service',
          note: '',
        },
        officer: {
          title: 'Need help with your enlistment?',
          message: 'Select the most accurate option for your time in service',
          note: '',
        },
        number: {
          title: 'Service number or SSN',
          message:
          'Depending on the time of your service you may have been assigned a service number. If not then use your Social Security Number.',
          note: '',
        },
        nationalguardserved: {
          title: 'Why are we asking?',
          message: 'Either the state or country served is required for national guard service',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        discharged: {
          title: 'Need help determining if you have been discharged?',
          message: 'Provide the type of discharge and the corresponding details',
          note: '',
        },
        discharge: {
          type: {
            title: 'Need help with the type of discharge?',
            message: 'Please select the most appropriate type of discharge',
            note: '',
          },
          reason: {
            title: 'Need help with the reason for discharge?',
            message: 'Provide the reasons or circumstances of the discharge',
            note: '',
          },
          date: {
            title: 'Estimate the date if unsure',
            message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
        country: {
          title: 'Need help with your service country?',
          message: 'Provide the country for which you served. If you are National Guard only one of State or country is required.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of military history',
          item: 'Branch',
          unknown: 'Provide your military history below',
        },
        appendTitle: 'Do you have another period of service to report?',
        append: 'Add additional military history',
      },
      comments: 'Optional Comments',
      summarycomments: 'Optional Summary Comments',
      servicecomments: 'Optional Comments',
      otherthanhonorablecomments: 'Optional Comments',
      dischargecomments: 'Optional Comments',
    },
    disciplinary: {
      heading: {
        courtmartialchargedescription: 'What were your charges under the Uniform Code of Military Justice (UCMJ) for this offense? (Input one charge at a time. There will be an opportunity to input multiple entries.)',
        courtmartialinunitedstates: 'Did this court-martial take place in the U.S.?',
        courtmartiallocation: 'Where did this court-martial take place?',
        courtmartialoffensedate: 'What is the date of the offense for which you were court-martialed?',
        courtmartialoffenselocation: 'Where did it occur?',
        courtmartialtype: 'What type of court-martial did you have?',
        disciplinaryprocedurename: 'Which disciplinary action did you receive? (Check one. There will be an opportunity to input multiple entries.)',
        givenby: 'Who gave you this disciplinary action?',
        imprisonedwhen: 'When were you imprisoned?',
        involvedalcohol: 'Was alcohol involved?',
        involveddomesticviolence: 'Was domestic violence involved? For this section, "domestic violence" is a crime of violence (such as battery or assault) against your parents or guardians; child; dependent; current or former spouse; current or former partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; or someone with whom you share a child in common. This includes crimes that meet this definition even if the term “domestic violence” is not specifically used in the criminal charges or conviction.',
        involveddrugs: 'Were drugs involved?',
        involvedexplosives: 'Were explosives involved?',
        involvedfirearms: 'Were firearms involved?',
        offenseinunitedstates: 'Did this offense occur in the U.S.?',
        parolegranted: 'Were you granted parole or supervised release?',
        parolewhen: 'What are or were the dates of your parole or supervised release?',
        sentencemorethanyear: 'Were you sentenced to more than one year of imprisonment?',
        title: 'Disciplinary procedures',
        date: 'When did you receive this disciplinary action?',
        offenses:
        'Provide a description of the Uniform Code of Military Justice (UCMJ) offense(s) for which you were charged',
        court:
        'Provide the description of the military court or other authority in which you were charged',
        outcome: 'Provide the description of the final outcome of the disciplinary procedure',
        outcomeconsequences: 'What were the consequences of this disciplinary action? (Select all that apply.)',
        outcometype: 'What was the outcome for this charge?',
        whathappened: 'Why did you receive this disciplinary action? (Include a description of the offense for which you received this disciplinary action, when the offense occurred, and any other important details.)',
      },
      para: {
        another: 'Do you have another disciplinary action for this period of service to report?',
        courtmartialchargeanother: 'Do you have another charge for this offense to report?',
        courtmartialchargeinfo: 'TODO: remove this',
        info: 'Did you receive any disciplinary actions for this period of service?',
        or: 'or',
      },
      label: {
        apofpozipcode: 'What is the APO or FPO ZIP Code?',
        apofpodpozipcode: 'What is the APO/FPO/DPO ZIP Code for the U.S. military installation or U.S. diplomatic facility?',
        consequences: { ...disciplineSentenceOptions.asLocaleEn() },
        county: 'County or County equivalent',
        court: 'Title of court or convening authority, address, to include city and state or country if overseas',
        courtmartialcircumstances: 'What were the circumstances surrounding this offense? (Include what happened, why you were charged, who was involved, and any other important details.)',
        idk: "I Don't Know",
        imprisonedwhen: {
          fromdate: 'From (Month/Year)',
          todate: 'To (Month/Year)',
        },
        name: "Such as Court Martial, Article 15, Captain's mast, Article 135 Court of Inquiry, etc.",
        outcome: 'Such as found guilty, found not guilty, fine, reduction in rank, imprisonment, etc.',
        outcometype: {
          awaitingtrial: 'Awaiting trial',
          chargedismissed: 'Charge dismissed',
          chargedismissedafterdeferred: 'Charge dismissed or disposed of after a deferred adjudication or deferred judgment (not applicable for military under the UCMJ)',
          guilty: 'Guilty',
          nolleprosequi: 'Nolle Prosequi',
          notguilty: 'Not guilty',
          ontrial: 'On trial',
          other: 'Other',
        },
        parolewhen: {
          fromdate: 'From (Month/Year)',
          todate: 'To (Month/Year)',
        },
        pleaseexplain: 'Please explain.',
        usmilitaryinstallationname: 'What is the name of the U.S. military installation?',
        zipcode: 'ZIP Code',
      },
      help: {
        branch: {
          title: 'Need help determining disciplinary procedures?',
          message:
          'Have you been subject to court martial or other disciplinary procedure under the Uniform Code of Military Justice (UCMJ), such as Article 15, Captain&rsquo;s mast, Article 135 Court of Inquiry, etc?',
          note: '',
        },
        date: {
          title: 'Estimate the date if unsure',
          message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        offenses: {
          title: 'Need help with this description?',
          message:
          'Provide a description of the Uniform Code of Military Justice (UCMJ) offense(s) for which you were charged',
          note: '',
        },
        name: {
          title: 'Need help with the procedure name?',
          message:
          'Such as Court Martial, Article 15, Captain&rsquo;s mast, Article 135 Court of Inquiry, etc.',
          note: '',
        },
        court: {
          title: 'Need help with the court information?',
          message:
          'Title of court or convening authority, address, to include city and state or country if overseas',
          note: '',
        },
        outcome: {
          title: 'Need help with the outcome?',
          message:
          'Such as found guilty, found not guilty, fine, reduction in rank, imprisonment, etc.',
          note: '',
        },
      },
      collection: {
        summary: {
          title: 'Summary of disciplinary procedures',
          item: 'Procedure',
          unknown: 'Provide the disciplinary procedure below',
        },
        appendTitle:
        'In the last {{years}} years do you have additional military disciplinary procedures to report?',
        appendMessage:
        'In the last {{years}} years do you have additional military disciplinary procedures to report?',
        append: 'Add additional disciplinary procedures',
      },
      comments: 'Optional Comments',
      summarycomments: 'Optional Summary Comments',
      entrycomments: 'Optional Comments',
    },
    foreign: {
      heading: {
        title: 'Foreign military',
        organization: 'During your foreign service, which organization were you serving under?',
        name: 'Provide the name of the foreign organization',
        dates: 'Provide your period of service',
        country: 'Provide the name of the country',
        rank: 'Provide your highest position/rank held',
        division: 'Provide the division/department/office in which you served',
        circumstances:
        'Provide a description of the circumstances of your association with this organization',
        left: 'Provide a description of the reason for leaving this service',
        maintainscontact:
        'Do you maintain contact with current or former associates, colleagues, or acquaintances from your service in this organization?',
        contact: {
          details: 'Acquaintance contact details',
          name: "Provide the contact's full name",
          address: "Provide the contact's address",
          title: "Provide the contact's official title",
          dates: 'Provide the length of your association with the contact',
          frequency: 'Provide the frequency of contact',
          comments: 'Optional Comments',
        },
        comments: 'Optional Comments',
        contactanswercomments: 'Optional Comments',
        contactsummarycomments: 'Optional Summary Comments',
      },
      para: {
        served:
        "Have you ever served, as a civilian or military member in a foreign country's military, intelligence, diplomatic, security forces, militia, other defense force, or government agency?",
        contact:
        'Please provide full name, address (if known), official title, length of association, and frequency of contact for each former associate, colleague or acquaintance with whom you maintain contact.',
      },
      label: {
        organization: {
          military: 'Military (Army, Navy, Air Force, Marines, etc.)',
          intelligence: 'Intelligence Service',
          diplomatic: 'Diplomatic Service',
          security: 'Security Forces',
          militia: 'Militia',
          defense: 'Other Defense Forces',
          other: 'Other Government Agency',
        },
      },
      help: {
        served: {
          title: 'Need help with foreign military?',
          message:
          'If you have served in a foreign military or service it will help in processing your application',
          note: '',
        },
        organization: {
          title: 'Need help with foreign service?',
          message: 'The type of foreign service',
          note: '',
        },
        name: {
          title: 'Need help with the name of the foreign organization?',
          message: 'The organization name',
          note: '',
        },
        dates: {
          title: 'Estimate the date if unsure',
          message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        country: {
          title: 'Need help with the name of the country?',
          message: 'The country name',
          note: '',
        },
        rank: {
          title: 'Need help with the highest position/rank held?',
          message: 'The highest rank or position held within the service',
          note: '',
        },
        division: {
          title: 'Need help with the division/department/office?',
          message: 'The name for the division, department, or office',
          note: '',
        },
        circumstances: {
          title: 'Need help describing the circumstances?',
          message: 'Additional information regarding the circumstances of this foreign service',
          note: '',
        },
        left: {
          title: 'Need help with the reason for leaving?',
          message: 'Please provide any reasons for leaving this service',
          note: '',
        },
        maintainscontact: {
          title: 'Still in contact?',
          message:
          'If you are still in contact with any current or former foreign associates answer "Yes" and provide their contact information below.',
          note: '',
        },
        contact: {
          dates: {
            title: 'Tell us the full time range you were in contact with this person',
            message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          address: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
          frequency: {
            title: 'How often?',
            message: 'Tell us how often you were in contact with this person.',
            note: '',
          },
        },
      },
      collection: {
        foreign: {
          appendTitle: 'Do you have an additional foreign military service to report?',
          append: 'Add another foreign military service',
        },
        contacts: {
          summary: {
            title: 'Summary of foreign military contacts',
            item: 'Name',
            unknown: 'Provide foreign military contact below',
          },
          appendTitle: 'Do you have an additional foreign military service contact to report?',
          append: 'Add another contact',
        },
      },
      comments: 'Optional Comments',
      summarycomments: 'Optional Summary Comments',
    },
  },
  intro: {
    title: 'Military history',
    body:
      'You will be asked questions about your military history and be asked to provide details if necessary.',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with military history at once',
  },
  section: {
    name: 'Military history',
  },
  subsection: {
    intro: 'Introduction',
    selective: 'Selective service record',
    history: 'U.S. military',
    disciplinary: 'Disciplinary procedures',
    foreign: 'Foreign military',
    review: 'Review',
  },
  destination: {
    intro: 'Military intro',
    selective: 'Selective service record',
    history: 'U.S. military',
    disciplinary: 'Disciplinary procedures',
    foreign: 'Foreign military',
    review: 'Review military history',
  },
  selective: {
    heading: {
      born: 'Were you born a male after December 31, 1959?',
      registered: 'Have you registered with the Selective Service System (SSS)?',
      number: 'Provide registration number',
      message: '(The military stopped issuing Service Numbers July 1, 1969.  If you were issued a Service Number, enter it here.  If not, enter your Social Security Number)'
    },
    para: {
      or: 'or',
    },
    label: {
      idk: "I don't know",
      number: 'Note: Selective Service Number is not your Social Security Number',
      explanation: 'Provide an explanation',
    },
    aria: {
      idk: "I don't know for Have you registered with the Selective Service System (SSS)",
    },
    error: {
      birthdateBefore: { title: 'Your birthdate is prior to this date.' },
    },
    help: {
      born: {
        title: 'Why are we asking?',
        message: 'The selective service only applies to men born after this date.',
        note: '',
      },
      registered: {
        title: 'Need help with whether you have registered?',
        message:
          'The Selective Service website (see link below) provides additional resources which may assist in finding your registration number or eligibility',
        note: '',
      },
      number: {
        title: 'Need help with your registration number?',
        message:
          'If additional assistance in determining your registration number is required please refer to the Selective Service information below',
        note: '',
      },
      explanation: {
        title: 'Need help with this explanation?',
        message: "To help the investigation let us know why you haven't registered.",
        note: '',
      },
      remember: {
        title: "Can't remember your registration number?",
        message:
          'The Selective Service website, [www.sss.gov](https://www.sss.gov/) can help provide the registration number for persons who have registered.',
        note: '',
      },
    },
    comments: 'Optional Comments',
    answercomments: 'Optional Comments',
    numbercomments: 'Optional Comments',
    exemptioncomments: 'Optional Comments',
    dnkcomments: 'Optional Comments',
  },
  history: {
    heading: {
      served: 'Have you ever served in the U.S. Military?',
      served2013: 'Have you ever served in the U.S. or Foreign Military?',
      servedmerchantmarine: 'Have you ever served in the U.S. Merchant Marine?',
      service: 'Provide the branch of service you served in',
      status: 'Provide your status',
      officer: 'Officer or enlisted',
      number: 'Provide your service number',
      dates: 'Provide your dates of service',
      servicestate: 'State of service',
      nationalguardserved: 'Provide either the state or country served',
      country: 'Country of service',
      discharged:
        'Were you discharged from this instance of U.S. military service, to include Reserves, or National Guard?',
      details: 'Discharge details',
      discharge: {
        type: 'Provide the type of discharge you received',
        date: 'Provide the date of discharge listed above',
      },
    },
    label: {
      airforce: 'Air Force',
      airnationalguard: 'Air National Guard',
      army: 'Army',
      armynationalguard: 'Army National Guard',
      coastguard: 'Coast Guard',
      marinecorps: 'Marine Corps',
      navy: 'Navy',
      nationalguard: 'National Guard',
      merchantmarine: 'Merchant Marine',
      activeduty: 'Active Duty',
      activereserve: 'Active Reserve',
      inactivereserve: 'Inactive Reserve',
      officer: 'Officer',
      enlisted: 'Enlisted',
      na: 'Not applicable',
      discharge: {
        type: {
          honorable: 'Honorable',
          dishonorable: 'Dishonorable',
          lessthan: 'Under other than honorable conditions',
          general: 'General',
          badconduct: 'Bad conduct',
          other: ['Other', '', '(provide type)'],
          otherex: 'Provide other type of discharge',
        },
        reason: 'Provide the reason(s) for the discharge',
      },
    },
    help: {
      served: {
        title: 'Any U.S. Military branch',
        message:
          'If you have ever served in the Air Force, Air National Guard, Army, Army National Guard, Coast Guard, Marine Corps, or Navy answer "Yes".',
        note: '',
      },
      served2013: {
        title: 'Any U.S. or Foreign Military',
        message: 'If you have ever served in a U.S. or Forign Military answer "Yes".',
        note: '',
      },
      servedmerchantmarine: {
        title: 'U.S. Merchant Marine branch',
        message: 'If you have ever served in the Merchant Marine answer "Yes".',
        note: '',
      },
      service: {
        title: 'Need help with the branch of service?',
        message: 'Please provide the branch of service you belonged to during this period',
        note: '',
      },
      status: {
        title: 'Need help with your status?',
        message: 'Provide your current status with this service',
        note: '',
      },
      officer: {
        title: 'Need help with your enlistment?',
        message: 'Select the most accurate option for your time in service',
        note: '',
      },
      number: {
        title: 'Service number or SSN',
        message:
          'Depending on the time of your service you may have been assigned a service number. If not then use your Social Security Number.',
        note: '',
      },
      nationalguardserved: {
        title: 'Why are we asking?',
        message: 'Either the state or country served is required for national guard service',
        note: '',
      },
      dates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      discharged: {
        title: 'Need help determining if you have been discharged?',
        message: 'Provide the type of discharge and the corresponding details',
        note: '',
      },
      discharge: {
        type: {
          title: 'Need help with the type of discharge?',
          message: 'Please select the most appropriate type of discharge',
          note: '',
        },
        reason: {
          title: 'Need help with the reason for discharge?',
          message: 'Provide the reasons or circumstances of the discharge',
          note: '',
        },
        date: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
      country: {
        title: 'Need help with your service country?',
        message: 'Provide the country for which you served. If you are National Guard only one of State or country is required.',
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of military history',
        item: 'Branch',
        unknown: 'Provide your military history below',
      },
      appendTitle: 'Do you have additional military service to report?',
      append: 'Add additional military history',
    },
    comments: 'Optional Comments',
    summarycomments: 'Optional Summary Comments',
    servicecomments: 'Optional Comments',
    otherthanhonorablecomments: 'Optional Comments',
    dischargecomments: 'Optional Comments',
  },
  disciplinary: {
    heading: {
      title: 'Disciplinary procedures',
      date: 'Provide the date of the court martial or other disciplinary procedure',
      offenses:
        'Provide a description of the Uniform Code of Military Justice (UCMJ) offense(s) for which you were charged',
      name: 'Provide the name of the disciplinary procedure',
      court:
        'Provide the description of the military court or other authority in which you were charged',
      outcome: 'Provide the description of the final outcome of the disciplinary procedure',
    },
    para: {
      info:
        "In the last {{years}} years, have you been subject to court martial or other disciplinary procedure under the Uniform Code of Military Justice (UCMJ), such as Article 15, Captain's mast, Article 135 Court of Inquiry, etc?",
    },
    label: {
      name: "Such as Court Martial, Article 15, Captain's mast, Article 135 Court of Inquiry, etc.",
      court:
        'Title of court or convening authority, address, to include city and state or country if overseas',
      outcome:
        'Such as found guilty, found not guilty, fine, reduction in rank, imprisonment, etc.',
    },
    help: {
      branch: {
        title: 'Need help determining disciplinary procedures?',
        message:
          'Have you been subject to court martial or other disciplinary procedure under the Uniform Code of Military Justice (UCMJ), such as Article 15, Captain&rsquo;s mast, Article 135 Court of Inquiry, etc?',
        note: '',
      },
      date: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      offenses: {
        title: 'Need help with this description?',
        message:
          'Provide a description of the Uniform Code of Military Justice (UCMJ) offense(s) for which you were charged',
        note: '',
      },
      name: {
        title: 'Need help with the procedure name?',
        message:
          'Such as Court Martial, Article 15, Captain&rsquo;s mast, Article 135 Court of Inquiry, etc.',
        note: '',
      },
      court: {
        title: 'Need help with the court information?',
        message:
          'Title of court or convening authority, address, to include city and state or country if overseas',
        note: '',
      },
      outcome: {
        title: 'Need help with the outcome?',
        message:
          'Such as found guilty, found not guilty, fine, reduction in rank, imprisonment, etc.',
        note: '',
      },
    },
    collection: {
      summary: {
        title: 'Summary of disciplinary procedures',
        item: 'Procedure',
        unknown: 'Provide the disciplinary procedure below',
      },
      appendTitle:
        'In the last {{years}} years do you have additional military disciplinary procedures to report?',
      appendMessage:
        'In the last {{years}} years do you have additional military disciplinary procedures to report?',
      append: 'Add additional disciplinary procedures',
    },
    comments: 'Optional Comments',
    summarycomments: 'Optional Summary Comments',
    entrycomments: 'Optional Comments',
  },
  foreign: {
    heading: {
      title: 'Foreign military',
      organization: 'During your foreign service, which organization were you serving under?',
      name: 'Provide the name of the foreign organization',
      dates: 'Provide your period of service',
      country: 'Provide the name of the country',
      rank: 'Provide your highest position/rank held',
      division: 'Provide the division/department/office in which you served',
      circumstances:
        'Provide a description of the circumstances of your association with this organization',
      left: 'Provide a description of the reason for leaving this service',
      maintainscontact:
        'Do you maintain contact with current or former associates, colleagues, or acquaintances from your service in this organization?',
      contact: {
        details: 'Acquaintance contact details',
        name: "Provide the contact's full name",
        address: "Provide the contact's address",
        title: "Provide the contact's official title",
        dates: 'Provide the length of your association with the contact',
        frequency: 'Provide the frequency of contact',
        comments: 'Optional Comments',
      },
      comments: 'Optional Comments',
      contactanswercomments: 'Optional Comments',
      contactsummarycomments: 'Optional Summary Comments',
    },
    para: {
      served:
        "Have you ever served, as a civilian or military member in a foreign country's military, intelligence, diplomatic, security forces, militia, other defense force, or government agency?",
      contact:
        'Please provide full name, address (if known), official title, length of association, and frequency of contact for each former associate, colleague or acquaintance with whom you maintain contact.',
    },
    label: {
      organization: {
        military: 'Military (Army, Navy, Air Force, Marines, etc.)',
        intelligence: 'Intelligence Service',
        diplomatic: 'Diplomatic Service',
        security: 'Security Forces',
        militia: 'Militia',
        defense: 'Other Defense Forces',
        other: 'Other Government Agency',
      },
    },
    help: {
      served: {
        title: 'Need help with foreign military?',
        message:
          'If you have served in a foreign military or service it will help in processing your application',
        note: '',
      },
      organization: {
        title: 'Need help with foreign service?',
        message: 'The type of foreign service',
        note: '',
      },
      name: {
        title: 'Need help with the name of the foreign organization?',
        message: 'The organization name',
        note: '',
      },
      dates: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      country: {
        title: 'Need help with the name of the country?',
        message: 'The country name',
        note: '',
      },
      rank: {
        title: 'Need help with the highest position/rank held?',
        message: 'The highest rank or position held within the service',
        note: '',
      },
      division: {
        title: 'Need help with the division/department/office?',
        message: 'The name for the division, department, or office',
        note: '',
      },
      circumstances: {
        title: 'Need help describing the circumstances?',
        message: 'Additional information regarding the circumstances of this foreign service',
        note: '',
      },
      left: {
        title: 'Need help with the reason for leaving?',
        message: 'Please provide any reasons for leaving this service',
        note: '',
      },
      maintainscontact: {
        title: 'Still in contact?',
        message:
          'If you are still in contact with any current or former foreign associates answer "Yes" and provide their contact information below.',
        note: '',
      },
      contact: {
        dates: {
          title: 'Tell us the full time range you were in contact with this person',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        frequency: {
          title: 'How often?',
          message: 'Tell us how often you were in contact with this person.',
          note: '',
        },
      },
    },
    collection: {
      foreign: {
        appendTitle: 'Do you have an additional foreign military service to report?',
        append: 'Add another foreign military service',
      },
      contacts: {
        summary: {
          title: 'Summary of foreign military contacts',
          item: 'Name',
          unknown: 'Provide foreign military contact below',
        },
        appendTitle: 'Do you have an additional foreign military service contact to report?',
        append: 'Add another contact',
      },
    },
    comments: 'Optional Comments',
    summarycomments: 'Optional Summary Comments',
  },
};
